"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Node = void 0;
var Node;
(function (Node) {
    Node[Node["Continue"] = 100] = "Continue";
    Node[Node["SwitchingProtocols"] = 101] = "SwitchingProtocols";
    Node[Node["Processing"] = 102] = "Processing";
    Node[Node["EarlyHints"] = 103] = "EarlyHints";
    Node[Node["Ok"] = 200] = "Ok";
    Node[Node["Created"] = 201] = "Created";
    Node[Node["Accepted"] = 202] = "Accepted";
    Node[Node["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
    Node[Node["NoContent"] = 204] = "NoContent";
    Node[Node["ResetContent"] = 205] = "ResetContent";
    Node[Node["PartialContent"] = 206] = "PartialContent";
    Node[Node["MultiStatus"] = 207] = "MultiStatus";
    Node[Node["AlreadyReported"] = 208] = "AlreadyReported";
    Node[Node["ImUsed"] = 226] = "ImUsed";
    Node[Node["MultipleChoices"] = 300] = "MultipleChoices";
    Node[Node["MovedPermanently"] = 301] = "MovedPermanently";
    Node[Node["Found"] = 302] = "Found";
    Node[Node["SeeOther"] = 303] = "SeeOther";
    Node[Node["NotModified"] = 304] = "NotModified";
    Node[Node["UseProxy"] = 305] = "UseProxy";
    Node[Node["TemporaryRedirect"] = 307] = "TemporaryRedirect";
    Node[Node["PermanentRedirect"] = 308] = "PermanentRedirect";
    Node[Node["BadRequest"] = 400] = "BadRequest";
    Node[Node["Unauthorized"] = 401] = "Unauthorized";
    Node[Node["PaymentRequired"] = 402] = "PaymentRequired";
    Node[Node["Forbidden"] = 403] = "Forbidden";
    Node[Node["NotFound"] = 404] = "NotFound";
    Node[Node["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    Node[Node["NotAcceptable"] = 406] = "NotAcceptable";
    Node[Node["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
    Node[Node["RequestTimeout"] = 408] = "RequestTimeout";
    Node[Node["Conflict"] = 409] = "Conflict";
    Node[Node["Gone"] = 410] = "Gone";
    Node[Node["LengthRequired"] = 411] = "LengthRequired";
    Node[Node["PreconditionFailed"] = 412] = "PreconditionFailed";
    Node[Node["PayloadTooLarge"] = 413] = "PayloadTooLarge";
    Node[Node["UriTooLong"] = 414] = "UriTooLong";
    Node[Node["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    Node[Node["RangeNotSatisfiable"] = 416] = "RangeNotSatisfiable";
    Node[Node["ExpectationFailed"] = 417] = "ExpectationFailed";
    Node[Node["ImATeapot"] = 418] = "ImATeapot";
    Node[Node["MisdirectedRequest"] = 421] = "MisdirectedRequest";
    Node[Node["UnprocessableEntity"] = 422] = "UnprocessableEntity";
    Node[Node["Locked"] = 423] = "Locked";
    Node[Node["FailedDependency"] = 424] = "FailedDependency";
    Node[Node["UnorderedCollection"] = 425] = "UnorderedCollection";
    Node[Node["UpgradeRequired"] = 426] = "UpgradeRequired";
    Node[Node["PreconditionRequired"] = 428] = "PreconditionRequired";
    Node[Node["TooManyRequests"] = 429] = "TooManyRequests";
    Node[Node["RequestHeaderFieldsTooLarge"] = 431] = "RequestHeaderFieldsTooLarge";
    Node[Node["UnavailableForLegalReasons"] = 451] = "UnavailableForLegalReasons";
    Node[Node["InternalServerError"] = 500] = "InternalServerError";
    Node[Node["NotImplemented"] = 501] = "NotImplemented";
    Node[Node["BadGateway"] = 502] = "BadGateway";
    Node[Node["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    Node[Node["GatewayTimeout"] = 504] = "GatewayTimeout";
    Node[Node["HttpVersionNotSupported"] = 505] = "HttpVersionNotSupported";
    Node[Node["VariantAlsoNegotiates"] = 506] = "VariantAlsoNegotiates";
    Node[Node["InsufficientStorage"] = 507] = "InsufficientStorage";
    Node[Node["LoopDetected"] = 508] = "LoopDetected";
    Node[Node["BandwidthLimitExceeded"] = 509] = "BandwidthLimitExceeded";
    Node[Node["NotExtended"] = 510] = "NotExtended";
    Node[Node["NetworkAuthenticationRequired"] = 511] = "NetworkAuthenticationRequired";
})(Node = exports.Node || (exports.Node = {}));
//# sourceMappingURL=node.js.map